import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {observer, PropTypes} from 'mobx-react';
import $ from 'jquery';
import _ from 'lodash';
import {HeaderSubBar, PageMask} from 'fn-common-ui';

@observer
class PSEHeader extends React.Component {

  static propTypes = {
    store: PropTypes.observableObject.isRequired,
    location: PropTypes.objectOrObservableObject
  };

  constructor(props) {
    super(props);
    this.state = {backgroundColor1:'white',
                  backgroundColor2:'dimgrey',
                  keycapture:[]}
    this.headerStore = this.props.store.headerStore;
    this.userStore = this.props.store.userStore;
    this.focusRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.handleRouteChange();
    }
    this.focusRef.current.focus();
  }

  componentDidMount() {

    $('.dropdown-toggle').focus(() => {
      $('.dropdown.show').removeClass('show');
    });

    $('.dropdown-menu li:last-child a').keydown((e) => {
      // if user uses keyboard navigation, need to make sure we arent closing menu when user Shift+Tabs(goes to previous item)
      if (e.which == 9 && e.shiftKey) {
        // do nothing
      } else if (e.which == 9) {
        $('.dropdown.show').removeClass('show');
      }
    });

    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('showModal', this.closeMainMenu);
  }

  onFocus=()=>{
    console.log('its called');
    this.setState({
      backgroundColor1:'lightgrey'
    })
    console.log('back1');
  }
  onBlur=()=>{
    this.setState({
      backgroundColor1:'white'
    })
    console.log('back2')
  }
  onFocus2=()=>{
    console.log('its called');
    this.setState({
      backgroundColor2:'lightgrey'
    })
    console.log('back1');
  }
  onBlur2=()=>{
    if(!(this.state.keycapture.includes('Shift'))){
    window.setTimeout(function(){
      document.getElementById('training-hamburgerDrop').focus();
    },0);
  }
    this.setState({
      backgroundColor2:'dimgrey',
      keycapture:[]
    })
    console.log('back2')
  }

  onBlur3=(event)=>{
    console.log(event.key);
    this.state.keycapture.push(event.key);
    console.log(this.state.keycapture);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('showModal', this.closeMainMenu);
  }

  handleRouteChange() {
    this.closeMainMenu();
  }

  openDesktopAdminSubmenu = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!this.headerStore.adminSubMenuIsOpen) {
      this.headerStore.adminSubMenuIsOpen = true;
      $('.dropdown.show').removeClass('show');
      $('#linkBtn-admin').focus();
    }
  }

  updateWindowDimensions = _.debounce(() => {
    this.closeMainMenu();
  }, 200, {
    leading: true,
    trailing: false
  });

  toggleMainMenu = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.headerStore.toggleMainMenu();
    this.toggleContentScrolling();
  };

  closeMainMenu = () => {
    this.headerStore.closeMainMenu();
    this.headerStore.updateViewportDimensions();
    this.toggleContentScrolling();
  };

  toggleAdminSubMenu = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.headerStore.toggleAdminSubMenu();
  };

  toggleProfileSubMenu = () => {
    this.headerStore.toggleProfileSubMenu();
  };

  toggleHelpSubMenu = () => {
    this.headerStore.toggleHelpSubMenu();
  };

  handleExternalTabOpen = () => {
    this.headerStore.externalTabOpen();
    this.toggleContentScrolling();
  }

  onLogout = event => {
    event.preventDefault();
    this.userStore.logoutUser();
  };

  toggleContentScrolling() {
    if (this.headerStore.mainMenuIsOpen) {
      $('body:not(.fnnav__main)').css('overflow', 'hidden');
      $('body:not(.fnnav__main)').css('position', 'fixed');
      $('body').css('width', '100%');
    } else {
      $('body').css('overflow', 'auto');
      $('body').css('position', 'relative');
      $('body').css('width', 'auto');
    }
  }

  handleToggleWalkthrough = () => {
    this.joyrideStore.toggleTour();
  }

  renderProfileBlock = () => {
    return (<div>
      <i className="icon-profile" aria-hidden="true" />
      <span className="pull-right-of-icon">
        {`${this.userStore.user.firstName} ${this.userStore.user.lastName}`}<br/> {this.userStore.user.pseName || ''}
      </span>
    </div>)
  }

  renderBrandArea = () => {
    return (<div className="fnnav__header" tabIndex = "-1">
      <button type="button" id = "training-hamburgerDrop" className="navbar-toggle" onClick={this.toggleMainMenu} aria-haspopup="true" aria-expanded={this.headerStore.mainMenuIsOpen}>
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar"/>
        <span className="icon-bar"/>
        <span className="icon-bar"/>
      </button>
      <div className="fnnav__brand" tabIndex = "-1">
        <Link className="logo-home-link logo-container" to="/" tabIndex = "-1">
          <img className="fnnav__brand__desktop" src="/images/firstnet-logo-white.svg" alt="FirstNet logo"/>
          <img className="fnnav__brand__mobile" src="/images/firstnet-logo-white-mobile.svg" alt="FirstNet logo" tabIndex = "-1"/>
          <span className="sr-only">Go Home</span>
        </Link>
      </div>
    </div>)
  }

  renderMobileOnlyUserMenu = () => {
    return (<li className="mainnav-item multi-line-item white" role="presentation" ref={this.focusRef} onFocus = {this.onFocus} onBlur = {this.onBlur} style={{backgroundColor:this.state.backgroundColor1}}>
      <a id="profile-block" href="#profile" className="deaden mobile-profile-block">
        {this.renderProfileBlock()}
      </a>
    </li>)
  }


  render() {
    return (<header className="fnnav training-portal" role="banner">
        <div className={`fnnav__mainbar ${this.headerStore.mainMenuIsOpen
            ? 'open'
            : ''}`}>
          <div className="container">
            {this.renderBrandArea()}
            <nav id="main-menu" aria-label="Main Menu">
              <ul className="fnnav__main">
                {/* desktop */}
                {this.renderMobileOnlyUserMenu()}
                <li className="mainnav-item grey logout" role="presentation" ref={this.focusRef} onFocus = {this.onFocus2} onBlur = {this.onBlur2} onKeyDownCapture = {()=>this.onBlur3(event)} style={{backgroundColor:this.state.backgroundColor2}}>
                  <a href="#" onClick={this.onLogout}>
                    <i className="icon-log-out" aria-hidden="true" />
                    Log Out
                  </a>
                </li>

                {/* desktop */}
                <li className="desktop-iconItem dropdown walkthrough-navigation-menu">
                  <button id="profile-header-dropdown" type="button" className="dropdown-toggle" aria-expanded="false" data-toggle="dropdown" onFocus={this.handleDropdownToggleFocus}>
                    <i className="icon-profile" aria-hidden="true" />
                    <span className="sr-only">Toggle Profile Dropdown</span>
                  </button>
                  <ul id="profile-nav" className="dropdown-menu dropdown-menu-right" aria-labelledby="profile-header-dropdown">
                    <li role="presentation" className="desktop-profile-display multi-line-item">
                      <a id="profile-desktop" href="#profile" className="deaden" tabIndex="-1">
                        {this.renderProfileBlock()}
                      </a>
                    </li>
                    <li role="presentation">
                      <a href="#" onClick={this.onLogout}>
                        <i className="icon-log-out" aria-hidden="true" />
                        <span className="pull-right-of-icon">Log Out</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <PageMask dim={this.headerStore.mainMenuIsOpen} handleOnClick={this.closeMainMenu}/>
        <HeaderSubBar mainMenuIsOpen={this.headerStore.mainMenuIsOpen} logoSrc="/images/training-portal-new-name-logo.svg" logoAlt="FirstNet Training Portal logo">
        </HeaderSubBar>
      </header>
    );
  }
}

// Wrapper to inject location prop using useLocation (for react-router-dom v6+)
export default function PSEHeaderWithLocation(props) {
  const location = useLocation();
  return <PSEHeader {...props} location={location} />;
}
